import ApolloClient from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
// import TowerAPI from './TowerAPI.jsx';
import queries from './Queries.jsx';
import mutations from './Mutations.jsx';

// Apollo Client configuration
// For development: connect to localhost:4001 (default mgmt port)
// For production: connect to mgmt.cryptowergame.com via HTTPS
const BACKEND_HOST =
  typeof window !== 'undefined'
    ? process.env.NODE_ENV === 'production'
      ? 'admin.cryptowergame.com'
      : window.location.hostname === 'localhost'
      ? 'localhost:4001'
      : window.location.host
    : 'localhost:4001';

const PROTOCOL =
  typeof window !== 'undefined'
    ? process.env.NODE_ENV === 'production'
      ? 'https'
      : window.location.protocol.replace(':', '')
    : 'http';

const httpLink = new HttpLink({
  uri: `${PROTOCOL}://${BACKEND_HOST}/graphql`,
  credentials: 'include',
});

// Auth middleware to add JWT token to request headers
const authLink = setContext((_, { headers }) => {
  // Get the authentication token from localStorage if available
  const token =
    typeof window !== 'undefined' ? localStorage.getItem('authToken') : null;

  // Return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

// const GRAPHQL_ENDPOINT = `${PROTOCOL_WS}://${BACKEND_HOST}/graphql`;

class ClientService {
  constructor() {
    if (!ClientService.instance) {
      // Create client with auth middleware
      this.client = new ApolloClient({
        link: authLink.concat(httpLink),
        cache: new InMemoryCache(),
      });
      ClientService.instance = this;
    }
    return ClientService.instance;
  }

  /**
   * Users
   */
  getUsers() {
    return new Promise((resolve, reject) =>
      this.client
        .query({
          query: queries.USERS,
          fetchPolicy: 'network-only',
        })
        .then((data) => {
          const { users } = data.data;
          resolve(users);
        })
        .catch((err) => reject(err))
    );
  }

  /**
   * Towers
   */
  getTowers() {
    return new Promise((resolve, reject) =>
      this.client
        .query({
          query: queries.TOWERS,
          fetchPolicy: 'network-only',
        })
        .then((data) => {
          const { towers } = data.data;
          resolve(towers);
        })
        .catch((err) => reject(err))
    );
  }

  /**
   * Verify Towers
   */
  verifyListOfTowers() {
    return new Promise((resolve, reject) =>
      this.client
        .mutate({
          mutation: mutations.VERIFY_TOWERS,
          fetchPolicy: 'no-cache',
        })
        .then((data) => {
          const { verifyListOfTowers } = data.data;
          resolve(verifyListOfTowers);
        })
        .catch((err) => reject(err))
    );
  }

  /**
   * Verify Actions
   */
  verifyActionsByTower(ethId) {
    return new Promise((resolve, reject) =>
      this.client
        .mutate({
          mutation: mutations.VERIFY_ACTIONS,
          variables: {
            ethId,
          },
          fetchPolicy: 'no-cache',
        })
        .then((data) => {
          const { verifyActionsByTower } = data.data;
          resolve(verifyActionsByTower);
        })
        .catch((err) => reject(err))
    );
  }

  /**
   * Players
   */
  getPlayers() {
    return new Promise((resolve, reject) =>
      this.client
        .query({
          query: queries.PLAYERS,
          fetchPolicy: 'network-only',
        })
        .then((data) => {
          const { players } = data.data;
          resolve(players);
        })
        .catch((err) => reject(err))
    );
  }

  /**
   * Invites
   */
  getInvites() {
    return new Promise((resolve, reject) =>
      this.client
        .query({
          query: queries.INVITES,
          fetchPolicy: 'network-only',
        })
        .then((data) => {
          const { invites } = data.data;
          resolve(invites);
        })
        .catch((err) => reject(err))
    );
  }

  /**
   * Recipients
   */
  getRecipients() {
    return new Promise((resolve, reject) =>
      this.client
        .query({
          query: queries.RECIPIENTS,
          fetchPolicy: 'network-only',
        })
        .then((data) => {
          const { recipients } = data.data;
          resolve(recipients);
        })
        .catch((err) => reject(err))
    );
  }

  /**
   * Add Recipients
   */
  addRecipients(input) {
    return new Promise((resolve, reject) =>
      this.client
        .mutate({
          mutation: mutations.ADD_RECIPIENTS,
          variables: {
            input,
          },
          fetchPolicy: 'no-cache',
        })
        .then((data) => {
          const { addRecipients } = data.data;
          resolve(addRecipients);
        })
        .catch((err) => reject(err))
    );
  }

  /**
   * Verify Towers
   */
  sendAll() {
    return new Promise((resolve, reject) =>
      this.client
        .mutate({
          mutation: mutations.SEND_ALL,
          fetchPolicy: 'no-cache',
        })
        .then((data) => {
          const { sendAll } = data.data;
          resolve(sendAll);
        })
        .catch((err) => reject(err))
    );
  }

  // /**
  //  * Create new Client with websockets and authenticated HTTP
  //  */
  // connect = async (token) => {
  //   try {
  //     // Create authentificated ws client
  //     this.wsClient = await new SubscriptionClient(GRAPHQL_ENDPOINT, {
  //       reconnect: true,
  //       connectionParams: {
  //         authToken: token,
  //       },
  //     });

  //     this.wsClient.onConnected(() => {
  //       console.log('Client Connected.');
  //       TowerAPI.subscribeForBuildTower();
  //       TowerAPI.subscribeForTowerUpdates();
  //     });

  //     this.wsClient.onReconnected(() => console.log('Client Reconnected.'));

  //     this.wsClient.onDisconnected(() => console.log('Client Disonnected.'));

  //     this.wsClient.onError(() => {
  //       throw new Error('WSCLIENT_ERR:CONNECTION');
  //     });
  //     //
  //     this.wsLink = await new WebSocketLink(this.wsClient);
  //     //
  //     const subscriptionMiddleware = {
  //       applyMiddleware: async (options, next) => {
  //         options.authToken = token;
  //         next();
  //       },
  //     };
  //     //
  //     this.wsLink.subscriptionClient.use([subscriptionMiddleware]);
  //     //
  //     const authLink = setContext((_, { headers }) => ({
  //       headers: {
  //         ...headers,
  //         authorization: token,
  //       },
  //     }));
  //     //
  //     this.link = split(
  //       // split based on operation type
  //       ({ query }) => {
  //         const { kind, operation } = getMainDefinition(query);
  //         return kind === 'OperationDefinition' && operation === 'subscription';
  //       },
  //       this.wsLink,
  //       authLink.concat(httpLink),
  //     );
  //     //
  //     this.client = await new ApolloClient({
  //       link: this.link,
  //       cache: new InMemoryCache(),
  //     });
  //   } catch (e) {
  //     console.log(e);
  //     throw new Error('WSCLIENT_ERR:CONNECTION');
  //   }
  // };

  // /**
  //  * Remove Client with websockets and authenticated HTTP and create only HTTP for authentication
  //  */
  // disconnect = async () => {
  //   // Close websocket connection if exist
  //   if (this.wsLink) {
  //     await this.wsLink.subscriptionClient.unsubscribeAll();
  //     await this.wsLink.subscriptionClient.close(true, true);
  //   }
  //   this.wsClient = null;
  //   this.wsLink = null;
  //   // Create new unauthorized client
  //   this.client = await new ApolloClient({
  //     link: httpLink,
  //     cache: new InMemoryCache(),
  //   });
  // }
}

const instance = new ClientService();

export default instance;
